<form
    (ngSubmit)="addDefaultLinkedEmployee()"
    [formGroup]="defaultLinkedEmployeeForm"
    class="modal-wrapper">
    <div class="modal-header">
        <h2
            class="modal-title"
            id="exampleModalLabel">
            Add consultancy contract
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="employee-picker">
            <div class="modal-toolbar">
                <input
                    type="text"
                    placeholder="Search employee..."
                    name="filterText"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="filterText"
                />
                <span class="result-count">{{ filteredEmployees.length }} found</span>
                <span class="result-count">{{ checkedEmployees.length }} selected</span>
            </div>
            <div class="row">
                <div class="table__overflow">
                    <table class="table-view">
                        <tr>
                            <th
                                class="td-small pointer"
                                (click)="checkAll()">
                                <input
                                    class="pointer"
                                    type="checkbox"
                                    [checked]="allCheck" />
                            </th>
                            <th>Employee</th>
                        </tr>
                        <tr
                            *ngFor="let employee of filteredEmployees"
                            class="pointer"
                            (click)="check(employee)">
                            <td>
                                <input
                                    type="checkbox"
                                    [checked]="isChecked(employee)" />
                            </td>
                            <td>
                                <span>{{ employee.firstName }} {{ employee.lastName }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2 required">
                <label for="pricePerHour">Price per hour</label>
                <small
                    class="form-error"
                    *ngIf="defaultLinkedEmployeeForm.get('pricePerHour').invalid && defaultLinkedEmployeeForm.get('pricePerHour').touched">
                    Price per hour is required...
                </small>
                <input
                    type="number"
                    id="pricePerHour"
                    formControlName="pricePerHour" />
                <small>If AI finds a day rate, it is converted to hourly rate by dividing by 8.</small>
            </div>
            <div class="form-group m-b-2">
                <label for="budget">Budget (€)</label>
                <input
                    type="number"
                    id="budget"
                    formControlName="budget"
                    step="0.01"
                    min="0" />
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2 required">
                <label for="effectiveFrom">Effective from (date)</label>
                <small
                    class="form-error"
                    *ngIf="defaultLinkedEmployeeForm.get('effectiveFrom').invalid && defaultLinkedEmployeeForm.get('effectiveFrom').touched">
                    Effective date is required...
                </small>
                <input
                    type="date"
                    id="effectiveFrom"
                    formControlName="effectiveFrom" />
            </div>
            <div class="form-group m-b-2">
                <label for="effectiveTo">Effective to (date)</label>
                <input
                    type="date"
                    id="effectiveTo"
                    formControlName="effectiveTo" />
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2">
                <label for="contractFile">Contract (optional)</label>
                <app-file-upload formControlName="contractFile" type="file"></app-file-upload>
                <button
                    type="button"
                    class="button button--icon m-t-1"
                    [disabled]="aiExtracting"
                    (click)="extractInvoiceFieldsWithAi()">
                    <i class="las la-magic" aria-hidden="true"></i>
                    <span>{{ aiExtracting ? 'Extracting…' : 'AI extract invoice fields' }}</span>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2">
                <label for="poNumber">Purchase order (PO)</label>
                <input type="text" id="poNumber" formControlName="poNumber" />
            </div>
            <div class="form-group m-b-2">
                <label for="sesNumber">SES / invoicing approval</label>
                <input type="text" id="sesNumber" formControlName="sesNumber" />
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2">
                <label for="contractAgreementNumber">Contract / MSA number</label>
                <input type="text" id="contractAgreementNumber" formControlName="contractAgreementNumber" />
            </div>
        </div>
        <div class="row">
            <div class="form-group m-b-2">
                <label for="freeText">Invoice free text</label>
                <textarea id="freeText" rows="3" formControlName="freeText"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <input
            class="button"
            [ngClass]="defaultLinkedEmployeeForm.invalid ? 'button--disabled' : 'button--primary'"
            type="submit"
            value="Add"
            [disabled]="defaultLinkedEmployeeForm.invalid" />
        <button
            class="button button--outline"
            (click)="activeModal.dismiss()">
            Cancel
        </button>
    </div>
</form>
